export const encodeToBase64 = (str: string) => {
  return Buffer.from(str).toString('base64');
};

export const decodeFromBase64 = (str: string) => {
  return Buffer.from(str, 'base64').toString('utf-8');
};
